import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import type { GalleryJobberDetails } from '@/types/gallery'

const fetchGalleryEnrichmentDetails = async (galleryId: number): Promise<GalleryJobberDetails | null> => {
  const { data, error } = await supabase
    .from('gallery_jobber_details')
    .select('*')
    .eq('gallery_id', galleryId)
    .maybeSingle()

  if (error) throw error
  return data ?? null
}

export const useGalleryEnrichmentDetails = (galleryId?: number | null) => {
  return useQuery<GalleryJobberDetails | null>({
    queryKey: ['gallery-jobber-details', galleryId],
    enabled: !!galleryId,
    queryFn: () => fetchGalleryEnrichmentDetails(galleryId!),
    staleTime: 60_000,
  })
}

export default useGalleryEnrichmentDetails
